import React, { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import * as api from "../../../actions/api";
import EmailSmsTemplateFormData from "./EmailSmsTemplateFormData";
import encryptionService from "../../../services/encryptionService";

const EditEmailSmsTemplate = (props) => {
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "email-sms-template-entry";
  const UserInfo = encryptionService.decryptUserInfo();
  const UserName = UserInfo == 0 ? "" : UserInfo[0].name;

  const [formData, setFormData] = useState({
    EventType: "",
    RoleId: [],
    Receivers: "",
    copySMSTo: "",
    mSubject: "",
    MSG: "",
    TemplateMode: "",
    DryMode: false,
  });

  const [errorObject, setErrorObject] = useState({});
  const { id } = useParams();
  const queryClient = useQueryClient();

  useQuery(
    ["EmailSmsTemplateEntry", id],
    () =>
      api.getEmailSmsTemplates(id).then((res) => {
        setFormData(res.data);
        return res.data;
      }),
    {
      enabled: Boolean(id),
    }
  );

  const { mutate } = useMutation(api.UpdateEmailSmsTemplates, {
    onSuccess: (data) => {
      if (data.status == 200) {
        
        props.openNoticeModal({
          isOpen: true,
          msg: data.data.message,
          msgtype: data.data.success,
        });

        queryClient.getQueriesData("EmailSmsTemplateEntry"); // include the page name
        props.history.push("/email-sms-template-entry"); //page url
      } else {
        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });
      }
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    let data = { ...formData };
    data[name] = value;

    setFormData(data);
    setErrorObject({ ...errorObject, [name]: null });
  };

  const handleChangeTextEditor = (value, field) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [field]: value,
    }));
    setErrorObject((prevErrorObject) => ({
      ...prevErrorObject,
      [field]: null,
    }));
  };

  //====== Start Choosen Dropdown===========
  const handleChangeChoosenProps = (name, value) => {
    let data = { ...formData };
    data[name] = value;
    setFormData(data);
    //setErrorObject({ ...errorObject, [name]: "" });
    setErrorObject({ ...errorObject, [name]: value.length ? "" : errorObject[name] });

  };
  //====== End Choosen Dropdown===========

  const handleCheck = (e) => {
    const { name, checked } = e.target;
    setFormData({ ...formData, [name]: checked });
  };

  const handleReset = () => {
    setFormData({
      EventType: "",
      RoleId: [],
      Receivers: "",
      copySMSTo: "",
      mSubject: "",
      MSG: "",
      TemplateMode: "",
      DryMode: false,
    });
  };

  const validateForm = (formData) => {
    let validateFields = ["EventType",  "mSubject", "MSG"];
    let errorData = {};
    let isValid = true;
    validateFields.map((field) => {
      if (!formData[field] || 
        (field === "MSG" && formData[field] === "<p><br></p>") /* ||
        (field === "RoleId" && Array.isArray(formData[field]) && formData[field].length === 0) */
       ) {
          errorData[field] =
            DispensingLanguage[lan][menukey]["field is Required !"];
          isValid = false;
        }

    });
    setErrorObject(errorData);
    return isValid;
  };

  const handleUpdate = async (e) => {

    let updatedFormData = { ...formData };
    // Ensure RoleId is always an array of numbers
    if (typeof updatedFormData.RoleId === "string") {
      updatedFormData.RoleId = updatedFormData.RoleId.split(",").map((id) =>
        parseInt(id.trim())
      ); // Convert strings to numbers
    }

    if (validateForm(formData)) {
      console.log("Updated formData: ", updatedFormData);
      let fDtat = {
        ...updatedFormData,
        menukey: menukey,
        lan: lan,
        UserName: UserName,
      };
      mutate(fDtat);
    }
  };

  return (
    <>
      <EmailSmsTemplateFormData
        errorObject={errorObject}
        addProductForm={false}
        formData={formData}
        handleChange={handleChange}
        handleChangeTextEditor={handleChangeTextEditor}
        handleChangeChoosenProps={handleChangeChoosenProps}
        handleCheck={handleCheck}
        handleReset={handleReset}
        handleUpdate={handleUpdate}
        {...props}
      />
    </>
  );
};

export default EditEmailSmsTemplate;
